var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.languages),function(language){return _c('v-list-item',{key:language.locale,attrs:{"to":{ name: _vm.$route.name, params: { lang: language.locale } }}},[_c('v-list-item-title',[_vm._v(_vm._s(language.name))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }